import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';



class BasicDetailsSubDomain extends Component {
    state = {
        subdomain: "",
        error: false
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ subdomain: nextProps.name, error: nextProps.nameError });
    }

    onChange = (e) => {
        let error = false;
        if (typing.isEmpty(e.target.value)) {
            error = true;
        }
        if (!error) {
            if (!typing.isUrlFriendly(e.target.value)) {
                error = true;
            }
        }
        this.setState({ subdomain: e.target.value, error: error })
    }

    onBlur = (e) => {
        this.props.onAttributeUpdate({ subdomain: this.state.subdomain }, this.state.error, e.target.id)
    }

    render() {
        const { subdomain, error } = this.state;
        return (
            <TextField
                label="SUBDOMAIN"
                id="subdomain"
                style={{ marginTop: 8,marginBottom:8 }}
                placeholder="subdomain name"
                fullWidth
                margin="normal"
                error={error}
                value={subdomain}
                onBlur={this.onBlur}
                onChange={this.onChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )
    }
};
export default BasicDetailsSubDomain;